export default {
  'Resolution': 'Resolución',
  'Frame rate': 'Fotogramas por segundo',
  'The higher the frame rate, the smoother the animation': "Cuanto mayor sea la velocidad de fotogramas, más suave será la animación.",
}